<template>
	<div class="edit-pwd">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="115px" class="demo-ruleForm edit-password-form yq" label-position="left">
			<el-form-item label="手机号码">
				<p>{{userInfo.moblie}}</p>
			</el-form-item>
			<el-form-item label="图片验证码" prop="imgCode" :error="errMessage">
				<el-input placeholder="请输入图片验证码" v-model="ruleForm.imgCode" class="hint-input-code">
					<template slot="append">
						<img :src="'/user/manager/image?count='+count" alt @click="count++" />
					</template>
				</el-input>
			</el-form-item>

			<el-form-item label="手机验证码" prop="code">
				<el-input v-model="ruleForm.code" placeholder="请输入手机验证码 " maxlength="4">
					<template slot="append">
						<span style="width: 96px;cursor:pointer;padding: 0 12px;" @click="sendSmsCode">{{countDown? countDown+'秒':'获取验证码'}}</span>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="password">
				<el-input v-model="ruleForm.password" type="passWord"></el-input>
				<span class="password-point">密码由6-20位字母+数字组成，区分大小写</span>
			</el-form-item>

			<el-form-item label="确认新密码" prop="newPassword">
				<el-input v-model="ruleForm.newPassword" type="passWord"></el-input>
			</el-form-item>
		</el-form>
		<div class="formbtn" @click="submitForm('ruleForm')">保存</div>
	</div>
</template>
<script>
import rules from '../../store/rules.js'
import {
	mapGetters,
	mapActions,
	mapState
} from 'vuex'

export default {
	name: 'accountEdirPassword',
	data () {
		let validatepass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.ruleForm.password) {
				callback(new Error('两次输入密码不一致'))
			} else {
				callback()
			}
		}
		return {
			count: 0,
			countDown: 0,
			errMessage: '',
			ruleForm: {
				imgCode: '',
				code: '',
				password: '',
				newPassword: '',
			},
			rules: {
				...rules,
				newPassword: [{
					required: true,
					validator: validatepass,
					trigger: 'blur'
				},],
				imgCode: [{
					required: true,
					message: '请输入图片验证码',
					trigger: 'blur'
				}]
			}
		}
	},
	computed: {
		...mapGetters('user', ['userInfo'])
	},
	methods: {
		...mapActions('user', ['postCheckPassword', 'postUpdatePassword', 'getUserCode']),
		//验证码获取
		sendSmsCode () {
			this.$refs.ruleForm.validateField('imgCode', (err) => {
				if (err) {
					return
				}
				this.errMessage = ''
				if (this.countDown) {
					this.$message({
						message: '1分钟内不能重复发送验证码！',
						type: 'error'
					})
					return
				}
				var interval = null
				this.getUserCode({
					mobile: this.userInfo.moblie,
					code: this.ruleForm.imgCode
				}).then(data => {
					if (data.data.isSuccess) {
						this.$message({
							message: '验证码发送成功',
							type: 'success'
						})
						this.countDown = 60
						interval = setInterval(() => {
							this.countDown--
							if (!this.countDown) {
								clearInterval(interval)
							}
						}, 1000)
					} else {
						this.errMessage = data.data.message
					}

				})
			})
		},
		submitForm (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.postUpdate()
				} else {
					return false
				}
			})
		},
		postUpdate () {
			let data = {
				username: this.userInfo.username,
				code: this.ruleForm.code,
				newPassword: this.ruleForm.newPassword,
			}
			this.postUpdatePassword(data).then(res => {
				if (res.data.isSuccess) {
					let This = this
					this.$message({
						message: res.data.message,
						type: 'success'
					})
					setTimeout(function () {
						This.$emit('Close')
					}, 2000)
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
		}
	}
}

</script>


<style lang="scss" scoped>
.password-point {
	color: #c1c1c1;
	display: inline-block;
	margin-left: 30px;
	font-size: 12px;
}

.formbtn {
	margin: 44px 0 44px 115px;
}

.el-input {
	width: 300px;
}

.code-btn {
	float: right;
	width: 96px;
	height: 52px;
	border: 1px solid #e6e6e6;
	border-left: 0;
	margin-top: 25px;
	border-radius: 0 5px 5px 0;
	color: #666;
	text-align: center;
	line-height: 52px;
	cursor: pointer;
}
</style>
